/* Kafie 1901 Coffee — cart drawer.  Session 27, Aug 2026.

   WHY THIS EXISTS
   Before this file, clicking Add to bag turned the button into the word
   "Added" for 1500ms and then put it back. That is the exact failure NN/g
   documented in its add-to-cart study: the confirmation disappears before
   the shopper has verified what went in, and they are left asking "where
   did my bag go?". Everything here is built so the confirmation PERSISTS
   until the shopper dismisses it.

   DOUBLE-ADD WARNING — READ BEFORE EDITING
   theme.js already binds a submit handler to every .card__form on the
   page (homepage grid, compare table, journey picker — 12 forms on the
   homepage alone). This file DOES NOT bind .card__form, and must never
   bind it, nor .add, nor form[action*="cart/add"], nor a document-level
   submit delegate. Any of those fires IN ADDITION to theme.js's handler
   and adds two bags a click.

   So how does the drawer know an add happened? It WATCHES rather than
   binds. window.fetch is wrapped once, here, and a successful POST to
   cart/add.js opens the drawer. Watching cannot double-add, because it
   never adds — and it picks up every current and future add-to-cart on
   the site without anyone remembering to wire it up. theme.js is
   untouched.

   Two adds are deliberately NOT auto-opened:
     - anything sending an `items` array. That is subscribe-builder on
       /pages/subscribe, which navigates to /cart itself; opening a drawer
       a beat before a page load is a flash of nothing.
     - our own add(), which paints and opens directly.
   Both scripts are deferred and theme.js is first in the document, but it
   only CALLS fetch on submit, long after this wrapper is installed.

   The PDP form is bound here by the class .pdp__form, which theme.js
   does not touch.

   Public surface, for other scripts:
     KafieCart.open()            open the drawer, fetching fresh state
     KafieCart.close()
     KafieCart.opened(cart)      "an add just happened" — render + open
     KafieCart.refresh()         re-read /cart.js and repaint
     KafieCart.add(id, qty)      add, then open
*/
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var el = document.getElementById('k6d');
  if (!el) return;

  var panel   = el.querySelector('[data-k6d-panel]');
  var veil    = el.querySelector('[data-k6d-veil]');
  var titleEl = el.querySelector('[data-k6d-title]');
  var listEl  = el.querySelector('[data-k6d-list]');
  var emptyEl = el.querySelector('[data-k6d-empty]');
  var footEl  = el.querySelector('[data-k6d-foot]');
  var shipEl  = el.querySelector('[data-k6d-ship]');
  var barEl   = el.querySelector('[data-k6d-bar]');
  var subEl   = el.querySelector('[data-k6d-sub]');
  var liveEl  = el.querySelector('[data-k6d-live]');
  var closeEl = el.querySelector('[data-k6d-close]');

  var THRESHOLD   = parseInt(el.getAttribute('data-threshold') || '7500', 10);
  var MONEY       = el.getAttribute('data-money') || '${{amount}}';
  var lastFocused = null;
  var busy        = false;
  var selfAdd     = false;   /* set while our own add() is in flight */

  /* ---------- helpers ---------- */

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var z = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY
      .replace(/\{\{\s*amount\s*\}\}/g, n)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, n)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, z)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, z);
  }

  function thumb(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function say(msg) { if (liveEl) liveEl.textContent = msg; }

  function json(url, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(root + url, opts).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Cart error'); },
                                      function () { throw new Error('Cart error'); });
      return r.json();
    });
  }

  /* ---------- painting ---------- */

  function paintHeaderCount(cart) {
    document.querySelectorAll('[data-cart-count], #cartCount').forEach(function (n) {
      n.textContent = cart.item_count;
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (n) {
      n.textContent = money(cart.total_price);
      if (cart.item_count > 0) { n.removeAttribute('hidden'); } else { n.setAttribute('hidden', ''); }
    });
  }

  function lineHTML(item, i) {
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var per = item.original_price ? money(item.original_price) + ' each' : '';
    /* line index in the Cart AJAX API is 1-based */
    var line = i + 1;
    var props = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (k.charAt(0) !== '_' && item.properties[k]) {
          props += '<span class="k6d__prop">' + esc(k) + ': ' + esc(item.properties[k]) + '</span>';
        }
      });
    }
    return '' +
      '<li class="k6d__line" data-line="' + line + '">' +
        '<a class="k6d__thumb" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
          (item.image ? '<img src="' + esc(thumb(item.image, 220)) + '" alt="" width="88" height="110" loading="lazy">' : '') +
        '</a>' +
        '<div class="k6d__meta">' +
          '<a class="k6d__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (variant ? '<p class="k6d__var">' + esc(variant) + '</p>' : '') +
          (props ? '<p class="k6d__var">' + props + '</p>' : '') +
          (per ? '<p class="k6d__each">' + per + '</p>' : '') +
          '<div class="k6d__qty">' +
            '<div class="k6step" role="group" aria-label="Quantity for ' + esc(item.product_title) + '">' +
              '<button type="button" class="k6step__b" data-step="-1" data-line="' + line + '" aria-label="Remove one ' + esc(item.product_title) + '">&minus;</button>' +
              '<input class="k6step__n" type="text" inputmode="numeric" pattern="[0-9]*" value="' + item.quantity + '" data-qty="' + line + '" aria-label="Quantity, ' + esc(item.product_title) + '">' +
              '<button type="button" class="k6step__b" data-step="1" data-line="' + line + '" aria-label="Add one ' + esc(item.product_title) + '">+</button>' +
            '</div>' +
            '<button type="button" class="k6d__rm" data-remove="' + line + '">Remove</button>' +
          '</div>' +
        '</div>' +
        '<p class="k6d__price">' + money(item.final_line_price) + '</p>' +
      '</li>';
  }

  function paint(cart, justAdded) {
    paintHeaderCount(cart);

    if (titleEl) titleEl.textContent = justAdded ? 'Added to your bag' : 'Your bag';

    if (!cart.items || cart.item_count === 0) {
      listEl.innerHTML = '';
      listEl.setAttribute('hidden', '');
      footEl.setAttribute('hidden', '');
      emptyEl.removeAttribute('hidden');
      return;
    }

    emptyEl.setAttribute('hidden', '');
    listEl.removeAttribute('hidden');
    footEl.removeAttribute('hidden');

    listEl.innerHTML = cart.items.map(lineHTML).join('');
    subEl.textContent = money(cart.total_price);

    /* Shipping in words. The evidence is for stating the cost and the
       threshold plainly — the animated bar underneath is decoration and
       is allowed to be, but the sentence has to carry the meaning on its
       own for anyone who cannot see the bar. */
    var left = THRESHOLD - cart.total_price;
    if (left > 0) {
      shipEl.innerHTML = 'Add <b>' + money(left) + '</b> more and U.S. shipping is free.';
      shipEl.classList.remove('is-done');
      barEl.style.width = Math.max(2, Math.min(100, (cart.total_price / THRESHOLD) * 100)) + '%';
      barEl.parentNode.removeAttribute('hidden');
    } else {
      shipEl.innerHTML = '<b>Your order ships free.</b>';
      shipEl.classList.add('is-done');
      barEl.style.width = '100%';
      barEl.parentNode.removeAttribute('hidden');
    }
  }

  /* ---------- open / close, focus, scroll lock ---------- */

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'),
      function (n) { return !n.hasAttribute('hidden') && n.getClientRects().length > 0; }
    );
  }

  function trap(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(justAdded) {
    if (el.classList.contains('open')) return;
    lastFocused = document.activeElement;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', trap);
    /* let the transform start before we move focus, or Safari jumps */
    setTimeout(function () { if (closeEl) closeEl.focus(); }, 60);
    if (!justAdded) refresh();
  }

  function close() {
    if (!el.classList.contains('open')) return;
    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.removeEventListener('keydown', trap);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* ---------- mutations ---------- */

  function setQty(line, qty) {
    if (busy) return;
    busy = true;
    el.classList.add('is-busy');
    json('cart/change.js', { line: line, quantity: qty })
      .then(function (cart) {
        paint(cart, false);
        say(qty === 0 ? 'Item removed. ' + cart.item_count + ' in your bag.'
                      : 'Quantity updated. ' + cart.item_count + ' in your bag.');
      })
      .catch(function (err) { say(err.message || 'Could not update the bag.'); })
      .then(function () { busy = false; el.classList.remove('is-busy'); });
  }

  function refresh() {
    return json('cart.js').then(function (cart) { paint(cart, false); return cart; });
  }

  function add(id, qty) {
    selfAdd = true;
    return json('cart/add.js', { id: id, quantity: qty || 1 })
      .then(function () { return json('cart.js'); })
      .then(function (cart) {
        selfAdd = false;
        paint(cart, true);
        open(true);
        say('Added. ' + cart.item_count + ' in your bag.');
        return cart;
      })
      .catch(function (err) { selfAdd = false; throw err; });
  }

  /* ---------- watch every other add on the site ----------
     See the header note. This wraps fetch; it does not bind a form. */
  (function watchAdds() {
    if (typeof window.fetch !== 'function' || window.__k6CartWatch) return;
    window.__k6CartWatch = true;
    var native = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var bulk = false;
      if (isAdd && init && typeof init.body === 'string') {
        try { bulk = !!JSON.parse(init.body).items; } catch (e) { bulk = false; }
      }
      var out = native.apply(this, arguments);
      if (!isAdd || bulk || selfAdd) return out;
      return out.then(function (res) {
        if (res && res.ok) {
          /* let the caller's own .then() run first, then take over */
          setTimeout(function () {
            json('cart.js').then(function (cart) {
              paint(cart, true);
              open(true);
              say('Added. ' + cart.item_count + ' in your bag.');
            }).catch(function () {});
          }, 0);
        }
        return res;
      });
    };
  })();

  /* ---------- wiring ---------- */

  el.addEventListener('click', function (e) {
    if (e.target === veil || e.target.closest('[data-k6d-close]')) { e.preventDefault(); close(); return; }

    var stepBtn = e.target.closest('[data-step]');
    if (stepBtn) {
      var ln = parseInt(stepBtn.getAttribute('data-line'), 10);
      var field = el.querySelector('[data-qty="' + ln + '"]');
      var next = Math.max(0, (parseInt(field.value, 10) || 0) + parseInt(stepBtn.getAttribute('data-step'), 10));
      field.value = next;
      setQty(ln, next);
      return;
    }

    var rm = e.target.closest('[data-remove]');
    if (rm) { setQty(parseInt(rm.getAttribute('data-remove'), 10), 0); }
  });

  /* Typed quantity commits on Enter and on blur — never silently, and
     never behind an "Update" button. Baymard's finding is that shoppers
     change the number, never press Update, and order the wrong amount. */
  el.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.hasAttribute && e.target.hasAttribute('data-qty')) {
      e.preventDefault();
      e.target.blur();
    }
  });
  el.addEventListener('change', function (e) {
    if (!e.target.hasAttribute || !e.target.hasAttribute('data-qty')) return;
    var n = parseInt(e.target.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    setQty(parseInt(e.target.getAttribute('data-qty'), 10), n);
  });

  /* Header bag button. Falls back to /cart if this script never runs. */
  document.querySelectorAll('[data-cart-open]').forEach(function (n) {
    n.addEventListener('click', function (e) { e.preventDefault(); open(false); });
  });

  /* The product page form. theme.js binds .card__form only, so this class
     is ours alone and cannot double-fire. */
  document.querySelectorAll('.pdp__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      if (!idField) return;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      add(idField.value, parseInt(qtyField && qtyField.value, 10) || 1)
        .catch(function (err) { say(err.message || 'Could not add to the bag.'); })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  });

  /* A quantity stepper anywhere outside the drawer (the PDP buy box). */
  document.querySelectorAll('[data-k6qty]').forEach(function (group) {
    var field = group.querySelector('input');
    group.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]');
      if (!b || !field) return;
      var n = (parseInt(field.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
      field.value = Math.max(1, Math.min(99, n));
    });
  });

  /* Back-button / bfcache: the header count is baked into the HTML, so a
     cached page shows a stale number. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) json('cart.js').then(paintHeaderCount).catch(function () {});
  });

  window.KafieCart = {
    open: function () { open(false); },
    close: close,
    refresh: refresh,
    add: add,
    opened: function (cart) { if (cart) { paint(cart, true); open(true); say('Added. ' + cart.item_count + ' in your bag.'); } else { open(false); } }
  };
})();
